export default __webpack_public_path__ + "static/media/tema2.788f09bd.png";